
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import { getTemDetail } from "@/request/ceping";
import TemplateTransfer from "@/components/template-transfer-pc/template-transfer/template-transfer.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    TemplateTransfer,
  },
})
export default class Name extends Vue {
  private data: any = {};
  private getData() {
    if (!this.data.template_id) {
      return;
    }
    const params: any = {
      template_id: this.data.template_id,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    getTemDetail(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    this.$store.commit("updateIfCompose", false);
    this.data.template_id = this.$route.query.id;
    this.getData();
  }
}
